'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _PeerReviewForm = require('./PeerReviewForm.scss');

var _PeerReviewForm2 = _interopRequireDefault(_PeerReviewForm);

var _LoadingButton = require('components/Loader/LoadingButton');

var _LoadingButton2 = _interopRequireDefault(_LoadingButton);

var _Loader = require('components/Loader/Loader');

var _Loader2 = _interopRequireDefault(_Loader);

var _reactRedux = require('react-redux');

var _trip = require('redux/modules/trip');

var _reactRouterRedux = require('react-router-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  PeerReviewForm: {
    displayName: 'PeerReviewForm'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/PeerReviewForm.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import { FormattedMessage } from 'react-intl';

// import { commaizeInt, getDisplayPrice } from 'utils/helpers';
// import { ceil } from 'utils/price';

var PeerReviewForm = _wrapComponent('PeerReviewForm')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    trip: state.trip.data,
    data: state.trip.peerReviewData,
    peerTrips: state.trip.peerTrips,
    isLoading: state.trip.isLoadingPeerReview,
    isSubmitting: state.trip.isSubmittingPeerReview
  };
}, { submitPeerReview: _trip.submitPeerReview, openPeerReview: _trip.openPeerReview, updatePeerTrips: _trip.updatePeerTrips, push: _reactRouterRedux.push }), _dec2 = (0, _reactCssModules2.default)(_PeerReviewForm2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PeerReviewForm, _Component);

  // constructor(props) {
  //   super(props);
  //   this.renderSalePrice = this.renderSalePrice.bind(this);
  // }
  // getQuantity = () => {
  //   const {trip, sessionData} = this.props;
  //   if (trip.is_per_day !== true) {
  //     return sessionData.quantity > trip.max_travelers ? trip.max_travelers : sessionData.quantity;
  //   }
  //   return sessionData.quantity > trip.max_day ? trip.max_day : sessionData.quantity;
  // }
  // renderSalePrice() {
  //   const {currency} = this.props.sessionData;
  //   const {trip, omitBookingFee, rates, siteConfigs} = this.props;
  //   const quantity = this.getQuantity();
  //   if (siteConfigs.fixYuan) {
  //     return (
  //       <span styleName="mobile-sale-price">{commaizeInt(ceil(getDisplayPrice(quantity, trip.full_prices, omitBookingFee), 'CNY', rates))} 元/
  //         {
  //           trip.is_per_day === true ? <FormattedMessage id="trip.detail.head.day"/> : <FormattedMessage id="trip.detail.head.person"/>
  //         }
  //       </span>
  //     );
  //   }
  //   return (
  //     <span styleName="mobile-sale-price">{commaizeInt(ceil(getDisplayPrice(quantity, trip.full_prices, omitBookingFee), currency, rates))} {currency}/
  //       {
  //         trip.is_per_day === true ? <FormattedMessage id="trip.detail.head.day"/> : <FormattedMessage id="trip.detail.head.person"/>
  //       }
  //     </span>
  //   );
  // }
  function PeerReviewForm(props) {
    (0, _classCallCheck3.default)(this, PeerReviewForm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PeerReviewForm.__proto__ || (0, _getPrototypeOf2.default)(PeerReviewForm)).call(this, props));

    _this.onSubmit = _this.onSubmit.bind(_this);

    if (!(typeof _this.onSubmit === 'function')) {
      throw new TypeError('Value of "this.onSubmit" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.onSubmit));
    }

    _this.state = {
      score: 0,
      checked: false
      // loading: true,
      // done: true,
    };
    return _this;
  }

  (0, _createClass3.default)(PeerReviewForm, [{
    key: 'onSubmit',
    value: function onSubmit() {
      var _this2 = this;

      this.props.submitPeerReview(this.props.trip.slug, this.state.score, this.state.checked).then(function () {
        var peerTrips = _this2.props.peerTrips;

        _this2.setState({ score: 0 });
        _this2.props.openPeerReview(false);
        if (!peerTrips || peerTrips.length === 0) {
          _this2.props.push('/dashboard/peer-review?done=true');
        } else {
          _this2.props.push('/trip/' + peerTrips[0].slug + '?peerReview=true');
          _this2.props.updatePeerTrips(peerTrips.slice(1));
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      if (this.props.isLoading) {
        return _react3.default.createElement(
          'div',
          { styleName: 'loader-container' },
          _react3.default.createElement(_Loader2.default, null)
        );
      }
      if (this.props.data && this.props.data._id) {
        return _react3.default.createElement(
          'div',
          { styleName: 'main-container' },
          _react3.default.createElement(
            'h2',
            { styleName: 'header' },
            'Thankyou for your rating'
          ),
          _react3.default.createElement(
            'p',
            { styleName: 'description' },
            'You already gave rating to this trip.'
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'rating' },
            [1, 2, 3, 4, 5].map(function (score) {
              return _react3.default.createElement('div', { key: 'score-' + score, styleName: _this3.props.data.score >= score ? 'star' : 'star-o' });
            })
          ),
          _react3.default.createElement(
            'p',
            { styleName: 'score-text' },
            function () {
              switch (_this3.props.data.score) {
                case 1:
                  return _react3.default.createElement(
                    'span',
                    null,
                    'Poor'
                  );
                case 2:
                  return _react3.default.createElement(
                    'span',
                    null,
                    'Below average'
                  );
                case 3:
                  return _react3.default.createElement(
                    'span',
                    null,
                    'Normal'
                  );
                case 4:
                  return _react3.default.createElement(
                    'span',
                    null,
                    'Good'
                  );
                case 5:
                  return _react3.default.createElement(
                    'span',
                    null,
                    'Excellent'
                  );
                default:
                  return _react3.default.createElement('span', null);
              }
            }()
          ),
          this.props.data.can_do_this_trip && _react3.default.createElement(
            'p',
            null,
            'You can do this trip'
          )
        );
      }
      return _react3.default.createElement(
        'div',
        { styleName: 'main-container' },
        _react3.default.createElement(
          'h2',
          { styleName: 'header' },
          'How local is this trip?'
        ),
        _react3.default.createElement(
          'p',
          { styleName: 'description' },
          'Please give a score on how local this trip is (scale 1-5).'
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'rating' },
          [1, 2, 3, 4, 5].map(function (score) {
            return _react3.default.createElement('div', { key: 'score-' + score, styleName: _this3.state.score >= score ? 'star' : 'star-o', onClick: _this3.props.isSubmitting ? function () {} : function () {
                return _this3.setState({ score: score });
              } });
          })
        ),
        _react3.default.createElement(
          'p',
          { styleName: 'score-text' },
          function () {
            switch (_this3.state.score) {
              case 1:
                return _react3.default.createElement(
                  'span',
                  null,
                  'Poor'
                );
              case 2:
                return _react3.default.createElement(
                  'span',
                  null,
                  'Below average'
                );
              case 3:
                return _react3.default.createElement(
                  'span',
                  null,
                  'Normal'
                );
              case 4:
                return _react3.default.createElement(
                  'span',
                  null,
                  'Good'
                );
              case 5:
                return _react3.default.createElement(
                  'span',
                  null,
                  'Excellent'
                );
              default:
                return _react3.default.createElement(
                  'span',
                  null,
                  'Undecided'
                );
            }
          }()
        ),
        _react3.default.createElement(
          'label',
          { styleName: 'custom-checkbox' },
          _react3.default.createElement('input', { type: 'checkbox', checked: this.state.checked, onChange: this.props.isSubmitting ? function () {} : function () {
              return _this3.setState({ checked: !_this3.state.checked });
            } }),
          _react3.default.createElement(
            'span',
            null,
            'I can do this trip'
          )
        ),
        function () {
          if (_this3.state.score <= 0) {
            return _react3.default.createElement(
              'a',
              { styleName: 'btn-disable' },
              'Submit'
            );
          } else if (_this3.props.isSubmitting) {
            return _react3.default.createElement(
              'a',
              { styleName: 'btn-loading' },
              _react3.default.createElement(_LoadingButton2.default, null),
              'Submitting'
            );
          }
          return _react3.default.createElement(
            'a',
            { styleName: 'btn-submit', onClick: _this3.onSubmit },
            _react3.default.createElement(_LoadingButton2.default, null),
            'Submit'
          );
        }()
      );
    }
  }]);
  return PeerReviewForm;
}(_react2.Component), _class2.propTypes = {
  trip: _react2.PropTypes.object,
  data: _react2.PropTypes.object,
  isLoading: _react2.PropTypes.bool,
  isSubmitting: _react2.PropTypes.bool,
  peerTrips: _react2.PropTypes.array,
  push: _react2.PropTypes.func,
  openPeerReview: _react2.PropTypes.func,
  updatePeerTrips: _react2.PropTypes.func,
  submitPeerReview: _react2.PropTypes.func }, _temp)) || _class) || _class));

exports.default = PeerReviewForm;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TripDetail/PeerReviewForm.js
// module id = 1639
// module chunks = 0